import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '60vw' }]

const HourHand = ({ degrees }: { degrees: number }): React.ReactElement => {
  return (
    <div
      className="w-2/6 h-1/2 absolute top-1/2 left-1/2"
      style={{ transform: `translate(-50%, -50%) rotate(${degrees}deg)` }}
    >
      <div className="h-1/2 flex relative">
        <ResponsiveImage
          alt="clock minute arrow"
          imageClassName="h-full absolute left-1/2 -translate-x-1/2"
          mediaQuery={mediaQuery}
          srcKey="Math Vault/icons/watch-hour-hand.png"
        />
      </div>
    </div>
  )
}

const MinuteHand = ({ degrees }: { degrees: number }): React.ReactElement => {
  return (
    <div
      className="w-2/6 h-4/6 absolute top-1/2 left-1/2"
      style={{ transform: `translate(-50%, -50%) rotate(${degrees}deg)` }}
    >
      <div className="h-1/2 flex relative">
        <ResponsiveImage
          alt="clock minute arrow"
          imageClassName="h-full absolute left-1/2 -translate-x-1/2"
          mediaQuery={mediaQuery}
          srcKey="Math Vault/icons/watch-minute-hand.png"
        />
      </div>
    </div>
  )
}

const Clock = ({
  minutes,
  hours,
  className = '',
}: {
  minutes: number
  hours: number
  className?: string
  size?: number
}): React.ReactElement => {
  const minuteAngle = (360 * minutes) / 60
  const hourAngle = (360 * (hours + minutes / 60)) / 12
  const { t } = useTranslation('mathVault')
  return (
    <div aria-label={t('analogClock', { hours, minutes })} className={`relative h-full w-full ${className}`} role="img">
      <ResponsiveImage
        alt="clock-bg"
        imageClassName="absolute z-10 h-full w-full object-contain top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        mediaQuery={mediaQuery}
        srcKey="Math Vault/icons/analog-watch-bg.png"
      />
      <div className="absolute z-20 h-full w-full object-contain top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <HourHand degrees={hourAngle} />
        <MinuteHand degrees={minuteAngle} />
      </div>
      <ResponsiveImage
        alt="clock-bg"
        imageClassName="absolute h-1/14 w-1/14 z-30 object-contain top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        mediaQuery={mediaQuery}
        srcKey="Math Vault/icons/analog-watch-center-circle-transparent.png"
      />
    </div>
  )
}

export default Clock
